/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_No_Methods_TitleInputs */

const en_common_sign_no_methods_title = /** @type {(inputs: Common_Sign_No_Methods_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sign-in methods available`)
};

/**
* | output |
* | --- |
* | "No sign-in methods available" |
*
* @param {Common_Sign_No_Methods_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_no_methods_title = /** @type {((inputs?: Common_Sign_No_Methods_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_No_Methods_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_no_methods_title(inputs)
});
export { common_sign_no_methods_title as "common.sign.no_methods_title" }